module.exports = __webpack_public_path__ + "static/media/ihr_autohaus-min.684347ac.webp";